import Vue from 'vue'
import Vuex from 'vuex'
import Vuelidate from 'vuelidate'
import VueSimpleAlert from 'vue-simple-alert'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import VueCookies from 'vue-cookies'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/ko' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css
import DatePicker from 'vue2-datepicker'
import Toast from 'vue-toastification'
import { VueSpinners } from '@saeris/vue-spinners'
import VueTippy from 'vue-tippy'

import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Mousewheel,
  Autoplay
} from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

import './assets/css/reset.css'
import './assets/css/common.css'
import './assets/css/content.css'
import './assets/css/program.css'
import './assets/css/responsive.css'
import common from './assets/js/common/common.js'
import 'vue-toastification/dist/index.css'

// Swiper modules
SwiperClass.use([Pagination, Navigation, Mousewheel, Autoplay])
// -------------------------------------------------
// Global use
Vue.use(getAwesomeSwiper(SwiperClass))
// -------------------------------------------------

Vue.use(Vuex)
// Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(common)
Vue.use(VueCookies)

Vue.use(Vuelidate)
Vue.use(VueSimpleAlert)
Vue.use(DatePicker)
Vue.use(VueSpinners)
Vue.use(Toast, {
  position: 'top-center',
  timeout: 3000,
  draggable: false,
  pauseOnHover: false
})

Vue.use(VueTippy)

// 쿠키의 만료일은 7일이다. (글로벌 세팅) - 쿠키 만료일을 지정하지 않을 경우 적용 됨
Vue.$cookies.config('7d')
Vue.config.productionTip = false

// 필터 전역 설정
Vue.filter('numberComma', function(val) {
  if (val === null) return null
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js